import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import { serverFailure } from './actions'
import { authReducer } from './auth/reducers'
import { AUTH_STORE_ID } from './auth/types'
import { DataState } from './types'
import { userGroupsReducer } from './userGroups/reducers'
import { USER_GROUPS_STORE_ID } from './userGroups/types'
import { userReducer } from './user/reducers'
import { USER_STORE_ID } from './user/types'

export const dataReducer = combineReducers<DataState>({
  [AUTH_STORE_ID]: authReducer,
  [USER_GROUPS_STORE_ID]: userGroupsReducer,
  [USER_STORE_ID]: userReducer,
  serverError: (recentServerError = false, action) => {
    switch (action.type) {
      case getType(serverFailure): {
        return true
      }
      default:
        return recentServerError
    }
  },
})
